
;(function($, window, document) {
  
  const blocks = $('.block-impact');

  if (blocks.length > 0) {

    $.each(blocks, function() {

      const block = $(this);

      $('.statistic').on('mouseover', function() {
        const id = $(this).data('statid');

        block.find('.image img').removeClass('active');
        block.find(`.image .${id}`).addClass('active');

      });
      
    });
  }


  

// @ts-ignore
})(jQuery, window, document);